import { paramCase, capitalCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// routes

// sections

import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useLocales from 'src/hooks/useLocales';
import useSettings from 'src/hooks/useSettings';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import ShopNewEditForm from './ShopNewEditForm';
// ----------------------------------------------------------------------

export default function ShopCreate() {
  const { themeStretch } = useSettings();

  const { pathname } = useLocation();
  const { translate } = useLocales();
  const { name = '' } = useParams();

  const isEdit = pathname.includes('edit');

  return (
    <Page
      title={
        !isEdit ? `${translate('Shop.AddTitle')}` : `${translate('Shop.UpdateTitle')}`
      }
    >
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={
            !isEdit
              ? `${translate('Shop.CreateShop')}`
              : `${translate('Shop.EditShop')}`
          }
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            {
              name: `${translate('Shop.ShopList')}`,
              href: PATH_DASHBOARD.Shop.list,
            },
            {
              name: !isEdit
                ? `${translate('Shop.New')}`
                : `${translate('Shop.Update')}`,
            },
          ]}
        />
        <ShopNewEditForm />
      </Container>
    </Page>
  );
}
